/*
THIS COMPONENT IS INCLUDED IN FORM-EDIT REVIEW PAGE
 -----------------------------------------*/
let ReviewsTopFixed = (function () {
    const $checkbox = $('#checkbox_fixed_review');
    const $sortingInput = $('#input_fixed_sorting');

    let init = () => {
        initSortingInput();
        listenClickToFixed();
    };

    let initSortingInput = () => {
        if (!$checkbox.attr('checked')) {
            $sortingInput.addClass('hidden');
        }
    };

    let listenClickToFixed = () => {
        $checkbox.click(() => {
            $sortingInput.toggleClass('hidden');
        });
    };

    return {
        init: init
    }
})();

export default ReviewsTopFixed;
